(function () {
  if (window.__apcInit) return;
  window.__apcInit = true;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.apc-sw');
    if (!b) return;
    var card = b.closest('.apc');
    if (!card) return;
    card.querySelectorAll('.apc-sw').forEach(function (s) { s.classList.remove('is-on'); s.setAttribute('aria-pressed', 'false'); });
    b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true');
    var id = card.querySelector('input[name=id]'); if (id) id.value = b.getAttribute('data-id');
    var p = card.querySelector('.apc-price'); if (p) p.innerHTML = b.getAttribute('data-price-html');
    var c = card.querySelector('.apc-colour'); if (c) c.textContent = b.getAttribute('data-name');
    var btn = card.querySelector('.apc-atc');
    if (btn) {
      var ok = b.getAttribute('data-available') === 'true';
      btn.disabled = !ok;
      var sp = btn.querySelector('span'); if (sp) sp.textContent = ok ? btn.getAttribute('data-add') : btn.getAttribute('data-sold');
    }
    var img = b.getAttribute('data-img');
    if (img) { var im = card.querySelector('.apc-img img'); if (im) { im.src = img; im.removeAttribute('srcset'); } }
  });
  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('.apc-sort');
    if (!s) return;
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', s.value); u.searchParams.delete('page');
    window.location.href = u.toString();
  });
})();
